import React from "react";
import { useMeasure } from "../hooks/index.js";
import { motion } from "motion/react";

const ResizeablePanel = ({
  children,
  className = ""
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  const [ref, bounds] = useMeasure();

  return (
    <motion.div
      animate={{
        height: bounds.height || "auto"
      }}
      initial={false}
      // style={{ overflow: "hidden" }}
      className={className}
    >
      <div ref={ref}>{children}</div>
    </motion.div>
  );
};

export { ResizeablePanel };
